var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c('div',{staticClass:"text-center mb-3 d-flex align-items-center justify-content-center preloader-overlay"},[_c('div',[_c('b-spinner',{staticStyle:{"width":"6rem","height":"6rem"},attrs:{"variant":"primary"}}),(_vm.message)?_c('div',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }